module.exports = __webpack_public_path__ + "img/img_tixian@2x.09995873.png";